import { render, staticRenderFns } from "./GetHelpScanning.vue?vue&type=template&id=22ae3740"
import script from "./GetHelpScanning.vue?vue&type=script&lang=ts"
export * from "./GetHelpScanning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports